import { memo, useCallback } from 'react';
import Typography from '@mui/material/Typography';
import _map from 'lodash/map';
// Local files
import Item from './Item/Item';
import { StyledList } from './List.styled';
import ListSkeleton from 'components/Common/Feedback/ListSkeleton/ListSkeleton';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useCustomSelector from 'hooks/useCustomSelector';
import useStudyTasks from 'hooks/useStudyTasks';
import { studyTasksSelectors } from "features/studyTasks";

const StudyTasksList = ({ studyAnalysisId }) => {
  const { getStudyTasks } = useStudyTasks();
  const { data, pagination } = useCustomSelector(studyTasksSelectors.getStudyTasksData);
  const fetching = useCustomSelector(studyTasksSelectors.studyTasksIsFetching);

  const fetchStudyTasks = useCallback((id, offset) => {
    getStudyTasks({ id, offset });
  }, [getStudyTasks]);

  const handleScroll = ({ target: { scrollTop, scrollHeight, offsetHeight } }) => 
    (scrollTop + 65) >= scrollHeight - offsetHeight && pagination.total_count > pagination.count + pagination.offset && !fetching && fetchStudyTasks(studyAnalysisId, pagination.limit + pagination.offset);

  return (
    <StyledList onScroll={handleScroll}>
      {_map(data, (item) => <Item key={item.id} {...item} />)}
      {fetching && <ListSkeleton />}
      {data.length === 0 && !fetching && <Typography sx={{ textTransform: 'uppercase', textAlign: 'center' }}>No tasks</Typography>}
    </StyledList>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <StudyTasksList {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);